module.exports = __webpack_public_path__ + "static/media/perfil2.801ab520.png";